import React, { useContext, useState } from 'react';
import { StyleProp, StyleSheet, TextInput } from 'react-native';

import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  disabled = false,
  placeholder = '',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  type = 'text',
  style,
  onChangeText,
}: {
  disabled?: boolean;
  placeholder?: string;
  type?: string;
  style?: StyleProp<any>;
  onChangeText?: (s: string) => void;
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const [text, updateText] = useState(placeholder);
  const styles = StyleSheet.create({
    input: {
      ...style,
      height: 50,
      borderRadius: 5,
      borderWidth: 0.5,
      backgroundColor: colors.background[800],
      padding: 10,
      color: colors.text,
    },
  });
  return (
    <TextInput
      style={styles.input}
      editable={!disabled}
      selectTextOnFocus={!disabled}
      onChangeText={(t) => {
        updateText(t);
        onChangeText(t);
      }}
      value={text}
    />
  );
}
